export default "__VITE_ASSET__N993hvnS__"